import { Resources } from 'constants/resources';

import { usePermissions } from 'hooks/usePermissions';
import { CreateButton } from 'shared/mui/Buttons';
import { ListPage } from 'shared/react-admin/Pages/ListPage/ListPage';
import { Permission } from 'types/embedded/permission';

import { PresetsListContent } from './PresetsListContent';

export const PresetsList: React.FC = () => {
  const { hasResourcePermissions } = usePermissions();

  return (
    <ListPage
      actions={[
        hasResourcePermissions(Resources.Presets, [Permission.Full, Permission.Create]) && (
          <CreateButton key="create-presets" />
        ),
      ]}
      empty={false}
      headerTitle={{
        titleText: 'Пресеты',
      }}
      sort={{ field: 'id', order: 'DESC' }}
    >
      <PresetsListContent />
    </ListPage>
  );
};
